// extracted by mini-css-extract-plugin
export default {"slider":"Carousel_slider__tnXU5","img":"Carousel_img__YNNYw"};